import { render } from "./About.vue?vue&type=template&id=7dc11188&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=7dc11188&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7dc11188"

export default script